import { createContext, useContext, useEffect, useState } from 'react';
import { useBenefit } from './BenefitSelectedContext';
import { setCookie, getCookie, deleteCookie } from '../util/Cookie';

const UserContext = createContext(undefined);

export const ClientProvider = ({ children }) => {
    const _init_ = getCookie("client_data");
    const [client, setClient] = useState(_init_ ? JSON.parse(_init_) : null);

    useEffect(() => {
        setClient(_init_ ? JSON.parse(_init_) : null);
    }, [])

    const setUser = (client) => {
        if (client) {
            setCookie("client_data", JSON.stringify(client), 1); // expira em 1 dia
        } else {
            deleteCookie("client_data"); // se passar null, remove
        }

        setClient(client);
        return client;
    };

    return (
        <UserContext.Provider value={{ client, setClient: setUser }}>
            {children}
        </UserContext.Provider>
    );
};

export const useClient = () => {
    const context = useContext(UserContext);
    if (!context) throw new Error('useClient deve ser usado dentro de UserProvider');
    return context;
};